import WorkroomProjectInfoModule from './workroom-project-info.module'

export default WorkroomProjectInfoModule
